function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import cn from 'clsx';
import { string, shape, arrayOf } from 'prop-types';
import List from '../List/index.jsx';
import BackgroundContainer from '../../atoms/BackgroundContainer/index.jsx';
import MenuLink from '../../atoms/MenuLink/index.jsx';

/**
 * DeepLinksNavigation component.
 */
const DeepLinksNavigation = ({
  className,
  items,
  feature,
  placement
}) => {
  const hasChildren = items.some(item => (item === null || item === void 0 ? void 0 : item.children) && (item === null || item === void 0 ? void 0 : item.children.length) > 0);
  return /*#__PURE__*/React.createElement(BackgroundContainer, {
    className: cn('deep-links-navigation', className, hasChildren && 'deep-links-navigation--has-children')
  }, /*#__PURE__*/React.createElement("section", {
    className: "body-copy-small fluid-container deep-links-navigation__section"
  }, /*#__PURE__*/React.createElement(List, {
    className: 'deep-links-navigation__list' + (hasChildren ? " deep-links-navigation--has-children__list" : ""),
    "data-feature": feature,
    "data-placement": placement
  }, items.map((item, index) => /*#__PURE__*/React.createElement(List.Item, {
    key: `${item.label}-${item.relativeUrl || item.absoluteUrl}`,
    className: 'deep-links-navigation__item' + (hasChildren ? " deep-links-navigation--has-children__item" : ""),
    "data-component": "MenuLink",
    "data-index": index + 1,
    "data-item-name": item.label
  }, /*#__PURE__*/React.createElement(MenuLink, _extends({
    className: hasChildren ? "deep-links-navigation--has-children__title heading-6" : ""
  }, item), item.label), (item === null || item === void 0 ? void 0 : item.children) && item.children.length !== 0 && /*#__PURE__*/React.createElement(List, null, item.children.map(item2 => /*#__PURE__*/React.createElement(List.Item, {
    key: `${item2.label}-${item2.relativeUrl || item2.absoluteUrl}`,
    className: "deep-links-navigation--has-children__child"
  }, /*#__PURE__*/React.createElement(MenuLink, item2, item2.label)))))))));
};
DeepLinksNavigation.defaultProps = {
  className: null,
  items: [],
  feature: null,
  placement: null
};
DeepLinksNavigation.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,
  items: arrayOf(shape(MenuLink.propTypes)),
  feature: string,
  placement: string
} : {};
export default DeepLinksNavigation;